// extracted by mini-css-extract-plugin
module.exports = {"Selected":"Selected_Selected__2zr7U"};